import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { AESService } from '../encryption/aes.service';


@Injectable()
export class ListPermisionsService {

  constructor(public http: HttpClient, public config: ConfigService,private Cryptography : AESService) {
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.Cryptography.getItem('accesstoken',true) })
  };
  listPermissions(): Observable<any> {
    return this.http.get(this.config.baseURL + '/permission/getallpermission', this.httpOptions)
      .map((res) => { return res }

      );
  }
updatePermission(user):Observable<any>{
  return this.http.post<any>(this.config.baseURL + '/permission/changepermission',user, this.httpOptions)
      .map((res) => { return res }

      );
}
}
